/** Agrupación de tareas asignadas por auxiliar (vista admin BNT Asistente). */

export const ASSIGNED_TASKS_ASSIGN_ALL = "__all_aux__";
export const ASSIGNED_TASKS_FILTER_ALL = "all";
export const ASSIGNED_TASKS_FILTER_AWAITING = "awaiting";

/**
 * @param {object[]} openTasks
 * @returns {{ pending: object[], awaiting: object[] }}
 */
export function splitOpenTasksByStatus(openTasks = []) {
  const pending = [];
  const awaiting = [];
  for (const task of openTasks || []) {
    if (task?.aux_completed_at) awaiting.push(task);
    else pending.push(task);
  }
  return { pending, awaiting };
}

/**
 * @param {object[]} openTasks
 * @param {object[]} auxiliaries
 * @returns {Array<{ id: string, name: string, pending: object[], awaiting: object[], openCount: number }>}
 */
export function groupOpenTasksByAuxiliary(openTasks = [], auxiliaries = [], nameFn = (row) => row?.name || "") {
  const byId = new Map();
  for (const aux of auxiliaries || []) {
    if (!aux?.id) continue;
    byId.set(aux.id, {
      id: aux.id,
      name: nameFn(aux),
      pending: [],
      awaiting: [],
      openCount: 0,
    });
  }
  for (const task of openTasks || []) {
    const group = byId.get(task.assigned_to_user_id);
    if (!group) continue;
    if (task.aux_completed_at) group.awaiting.push(task);
    else group.pending.push(task);
    group.openCount += 1;
  }
  return Array.from(byId.values()).sort((a, b) => {
    if (b.openCount !== a.openCount) return b.openCount - a.openCount;
    return a.name.localeCompare(b.name, "es");
  });
}

/**
 * @param {object[]} openTasks
 * @param {object[]} auxiliaries
 * @param {(row: object) => string} nameFn
 */
export function buildAssignedTasksFilterChips(openTasks = [], auxiliaries = [], nameFn = (row) => row?.name || "") {
  const { awaiting } = splitOpenTasksByStatus(openTasks);
  const groups = groupOpenTasksByAuxiliary(openTasks, auxiliaries, nameFn);
  const chips = [
    {
      id: ASSIGNED_TASKS_FILTER_ALL,
      label: "Todos",
      count: openTasks.length,
    },
    {
      id: ASSIGNED_TASKS_FILTER_AWAITING,
      label: "Por validar",
      count: awaiting.length,
    },
  ];
  for (const group of groups) {
    chips.push({
      id: group.id,
      label: group.name,
      count: group.openCount,
    });
  }
  return chips;
}
